"use client";
import Link from "next/link";

export default function PageComponent({}) {
  return (
    <main className="page page-not-found">
      <div className="container-s">

        <div className="page-title-holder">
          <h1 className="h1-title">
            <span className="title en">Not Found</span>
          </h1>
          <div className="text-lead bold">
            お探しのページが見つかりません。
          </div>
        </div>

        <div className="button-holder">
          <Link className="button-round scaleHover size-s bold" href="/">
            <span className="inner">TOPにもどる</span>
          </Link>
        </div>

      </div>
    </main>
  );
}
